__turbopack_context__.v({
  "container": "AboutThisEventEmbedded-module-scss-module__N8WXJW__container",
  "hidden": "AboutThisEventEmbedded-module-scss-module__N8WXJW__hidden",
});
